// Recovered compiled webpack factory 64054. Edit this function expression; run npm run build.
(e, t) => {
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      bindSnapshot: function () {
        return s;
      },
      createAsyncLocalStorage: function () {
        return l;
      },
      createSnapshot: function () {
        return i;
      },
    }));
  let r = Object.defineProperty(
    Error("Invariant: AsyncLocalStorage accessed in runtime where it is not available"),
    "__NEXT_ERROR_CODE",
    { value: "E504", enumerable: !1, configurable: !0 },
  );
  class a {
    disable() {
      throw r;
    }
    getStore() {}
    run() {
      throw r;
    }
    exit() {
      throw r;
    }
    enterWith() {
      throw r;
    }
    static bind(e) {
      return e;
    }
  }
  let n = "undefined" != typeof globalThis && globalThis.AsyncLocalStorage;
  function l() {
    return n ? new n() : new a();
  }
  function s(e) {
    return n ? n.bind(e) : a.bind(e);
  }
  function i() {
    return n
      ? n.snapshot()
      : function (e, ...t) {
          return e(...t);
        };
  }
}
